<template>
    <div id="card">
      <div class="nav-card">
        <div class="nav-header">
          <ul class="nav-bar">
            <li v-for="(item,index) in topBarList" :key="index">
              <router-link :class="[$route.path.indexOf(item.key)!==-1?'link-active':'']" :to="item.url" :replace="index>1?true:''">{{item.title}}</router-link>
            </li>
          </ul>
          <ul class="nav-link">
            <li>
              <router-link :to="{path:others.navUrl}">{{others.navName}}</router-link>
            </li>
            <li v-if="$route.matched[1]">
              &gt;
              <router-link :to="$route.matched[1].path">{{$route.matched[1].meta.title}}</router-link>
            </li>
            <li v-if="$route.matched.length > 2">
              &gt;
              <router-link :to="$route.matched[2].path">{{$route.matched[2].meta.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="nav-body">
          <router-view></router-view>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: 'appointment',
    data () {
        return {

        }
    },
    props: ['topBarList', 'others']
}
</script>
<style lang="scss" scoped>
	#card {
		.nav-card {
			max-width: 1200px;
			position: relative;
			margin: 50px auto 100px;
			.nav-header {
				width: 100%;
				box-sizing: border-box;
				ul.nav-link {
					height: 16px;
					line-height: 16px;
					margin: 30px 0 20px 0;
					font-size: 16px;
					li {
						display: inline;
						color: #6C6A66;
						a {
							color: inherit;
						}
						&:last-child>a {
							color: #AD011B;
						}
					}
				}
				ul.nav-bar {
					text-align: center;
					li {
						display: inline-block;
						width: 270px;
						height: 60px;
						text-align: center;
						height: 60px;
						line-height: 60px;
						border: 1px solid #EDAA42;
						&:hover a {
							color: #fff;
							background-color: #edaa42;
						}
						>a {
							background: rgba(255, 255, 255, .7);
							display: block;
							width: auto;
							height: 100%;
							text-align: center;
							color: #323232;
							font-size: 20px;
							&.link-active {
								color: #fff;
								background: rgba(237, 170, 66, 0.9);
							}
						}
					}
				}
			}
			.nav-body {
				min-height: 500px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/cardthree.vue